export class ShowModal {
    constructor(ModalComponent, modalProps) {
        this.ModalComponent = ModalComponent;
        this.modalProps = modalProps;
        this.type = 'SHOW_MODAL';
    }
}
export class CloseModal {
    constructor() {
        this.type = 'CLOSE_MODAL';
    }
}
